import DOMPurify from "dompurify";

function TagValidation(value: string) {
    return DOMPurify.sanitize(value) !== value ? "" : value;
}

export default TagValidation;